import React from 'react';
import { Col, Row } from 'antd';
import styled from 'styled-components';
import { SRILevel } from 'Types/SRITypes';
import SkeletonCustom from 'Components/common/skeleton/SkeletonCustom';
import { minWidthApp } from 'Utils/utilsStyle';
import BeltWidget from './BeltWidget';
import StatesWidget from './StatesWidget';

const Wrapper = styled.div`
  padding: 0px 0px 0px 30px;
  .stateItemNum {
    @media all and (max-width: ${minWidthApp}){
      font-size: 23px;
    }
  }
`;

type Props = {
  level?: SRILevel,
  userTeamRank?: number,
  timeSpent?: number,
  scoreThisMonth?: number,
  companyViewed?: number,
  peopleViewed?: number,
  contentViewed?: number,
  loading?: boolean,
  userTeamMember?: number
};

const defaultProps = {
  level: {} as SRILevel,
  userTeamRank: 0,
  timeSpent: 0,
  scoreThisMonth: 0,
  companyViewed: 0,
  peopleViewed: 0,
  contentViewed: 0,
  loading: false,
  userTeamMember: 0,
};

const BadgeDetails = function BadgeDetails(props: Props) {
  const {
    level,
    userTeamRank,
    timeSpent,
    scoreThisMonth,
    companyViewed,
    peopleViewed,
    contentViewed,
    userTeamMember,
    loading,
  } = props;
  return (
    <Wrapper>
      <Row gutter={[16, 16]}>
        <Col span={9}>
          <BeltWidget
            beltShadow={level?.rgb}
            beltTitle={level?.text}
            beltImage={level?.gif}
            loading={loading}
          />
        </Col>
        <Col span={15}>
          <Row gutter={[16, 16]}>
            <Col span={8}>
              {
                loading ? <SkeletonCustom height="156px" width="100%" diameter="12px" />
                  : (
                    <StatesWidget
                      statesTitle="Company Rank"
                      oneliner
                      statesNumber={
                        userTeamRank && userTeamMember
                          ? `${userTeamRank?.toString()}` : 'N/A'
                      }
                    />
                  )
              }
            </Col>
            <Col span={8}>
              {
                loading ? <SkeletonCustom height="156px" width="100%" diameter="12px" />
                  : <StatesWidget oneliner statesTitle="Time Spent" statesNumber={timeSpent?.toString()} isTimeSpent />
              }
            </Col>
            <Col span={8}>
              {
                loading ? <SkeletonCustom height="156px" width="100%" diameter="12px" />
                  : <StatesWidget oneliner statesTitle="Total Score" statesNumber={scoreThisMonth?.toString()} />
              }
            </Col>
            <Col span={8}>
              {
                loading ? <SkeletonCustom height="156px" width="100%" diameter="12px" />
                  : <StatesWidget statesTitle="Company Viewed" statesNumber={companyViewed?.toString()} />
              }
            </Col>
            <Col span={8}>
              {
                loading ? <SkeletonCustom height="156px" width="100%" diameter="12px" />
                  : <StatesWidget statesTitle="People Viewed" statesNumber={peopleViewed?.toString()} />
              }
            </Col>
            <Col span={8}>
              {
                loading ? <SkeletonCustom height="156px" width="100%" diameter="12px" />
                  : <StatesWidget statesTitle="Content Viewed" statesNumber={contentViewed?.toString()} />
              }
            </Col>
          </Row>
        </Col>
      </Row>
    </Wrapper>
  );
};

BadgeDetails.defaultProps = defaultProps;

export default BadgeDetails;
